import { render, staticRenderFns } from "./FapiForm.vue?vue&type=template&id=5c615ad4"
import script from "./FapiForm.vue?vue&type=script&lang=ts"
export * from "./FapiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports